import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbOffcanvas, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../core/services/classroom.service';
import { CompositionService } from '../../../../core/services/composition.service';
import { FileService } from '../../../../core/services/file.service';
import { NoteService } from '../../../../core/services/note.service';
import { PeriodService } from '../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { StudentAyClassroomService } from '../../../../core/services/student-ay-classroom.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import {FileService as myFileService} from '../../../../core/utils/file-service'
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-professor-bulletin',
    templateUrl: './professor-bulletin.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./professor-bulletin.component.css']
})
export class ProfessorBulletinComponent {

  buttonsPermission :any|undefined;
 search_text=""
  classrooms:any[] =[]
  averages:any[] =[]
  roles:any[] =[]
  data:any
  notes:any[] =[]
  periods:any[] =[]
  compositions:any[] =[]
  courses:any[] =[]
  paccs:any[] =[]
  sacs:any[] =[]
  selected_data:any;
  modalOption:any; 
  classroomId:any; 
  sacId:any; 
  periodId:any; 
  currentCompositon:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-bulletin-appreciation"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any

  pdfViewLoader=false
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined


  constructor(
    private spinnerService:NgxSpinnerService,
    private noteService:NoteService,
    private fileService:FileService,
    private compService:CompositionService,
    private periodService:PeriodService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private classroomService:ClassroomService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
      private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getClassrooms()
    this.getPeriods()
  

  }

  getSacs(){
    this.sacs=[]
    this.sacService.getAll(this.classroomId).subscribe((res:any)=>{
      this.sacs=res.data
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des bulletins",err)
    })
  }
  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des bulletins",err)
    })
  }

  open2(content:any,el:any){
    this.modalService.open(content)
    this.selected_data=el
  }


  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des bulletins",err)

    })
  }

  open(i:any){
    this.pdfSrc=this.data[i].motif_file
    this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

  }
 

  getClassrooms(){
    this.classroomService.getByState(1).subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des bulletins",err)
    })
  }

  loadCompositions1(event:any){
    this.classroomId=event.target.value
    this.getSacs()
    if (this.classroomId != undefined && this.periodId!=undefined && this.sacId!=undefined) {
      this.getData()
    } 
   
  }
  
  loadCompositions2(event:any){
    this.periodId=event.target.value

    if (this.classroomId != undefined && this.periodId!=undefined && this.sacId!=undefined) {
      this.getData()
    } 
   
  }

  loadCompositions3(event:any){
    this.sacId=event.target.value

    if (this.classroomId != undefined && this.periodId!=undefined && this.sacId!=undefined) {
      this.getData()
    } 
   
  }

  getDataAll(){
    this.noteService.getAverageAll(this.classroomId,this.periodId).subscribe((res:any)=>{
      this.data=res.data
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des bulletins",err)

    })
  }

  getData(){
    this.spinnerService.show()
    this.compService.getOneBulletin(this.classroomId,this.periodId, this.sacId).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.data=res.data
          this.spinnerService.hide()

      },
      (err:any)=>{
        this.spinnerService.hide()

        console.log(err)
          AppErrorShow.showError("Gestion des bulletins",err)

      })
  }


  resetNote(event:any, i:any){
      if(event.target.value=="0")this.data[i].value=0
      this.data[i].isSetted=event.target.value=="0"?0:1
  }


  async upload(ev:any, i:any){
    if (ev.target.files.length!=0) {
      this.data[i].motif_file=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(ev.target.files[0]))
      this.data[i].hasFile=true
    }
  }


  remove(i:any){
    this.data[i].motif_file=""
    this.data[i].hasFile=false  
  }


  store(value:any){
    this.loading=true
    console.log(this.data)
    this.noteService.store({
      composition_id:value.composition_id,
      notes:this.data
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des bulletins",err)

    })
  }
  update(value:any){
    this.loading=true

    this.noteService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      this.data.find((el:any)=>el.id=this.selected_data.id).new_value=value.new_value

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des bulletins",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.sacService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des bulletins",err)

    })
  }
})
  }
  confirm(){
    let confirmed=AppSweetAlert.confirmBox('success','Note de composition','Voulez vous vraiment confirmer les notes de cette composition élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.compService.confirm(this.currentCompositon.id,1).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.init()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des bulletins",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des bulletins",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }
 
}
